<script>
import { FontAwesomeIcon } from "@fortawesome/svelte-fontawesome";
import { faXmark, faEnvelope, faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';
import { isSelectAllBtnDisabledStore, resultsStore } from "../stores/stores";
import { svgMailTenderIcon } from "../utils/utils";

export let result;
export let employeesWithTenderReceivedArray = [];

$: hasTenderAlreadyReceived = employeesWithTenderReceivedArray.includes(result.id);

async function removeResult() {
    resultsStore.update((results) => {
        return results.filter(r => r.id !== result.id);
    });
    enableResultInEmployeeRequest()
    isSelectAllBtnDisabledStore.set(false);
}

async function getEmployeeRequestElement(id) {
    return document.querySelector(`.employee-drag[data-ressourceid="${id}"]`);
}

async function disableResultInEmployeeRequest() {
    let employeeRequestElement = await getEmployeeRequestElement(result.id)
    if(employeeRequestElement) {
        employeeRequestElement.classList.add('disabled-tender');
    }
}

async function enableResultInEmployeeRequest() {
    let employeeRequestElement = await getEmployeeRequestElement(result.id)
    if(employeeRequestElement) {
        employeeRequestElement.classList.remove('disabled-tender');
    }
}

disableResultInEmployeeRequest();

/**
 * function addTooltipIfOverflow(element: HTMLElement) {
    if (element.offsetWidth < element.scrollWidth) {
        element.title = element.textContent;
    }
}

*/
</script>

<div data-ressourceid={result.id} data-ressourcename={result.name} data-overlap-icon="null" data-overlap-type="null" class="tender-recipient-chip">
    <p class="tender-resource-name-chip">{result.name}</p>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div on:click={removeResult}>
        <FontAwesomeIcon icon={faXmark} size="xl"/>
    </div>

    {#if hasTenderAlreadyReceived}
    <div class="mail-tender-icon">
        {@html svgMailTenderIcon}
    </div>
    {/if}

    {#if result.overlapping}
    <span style="color: {result.overlapping.color}; {hasTenderAlreadyReceived && 'right: 4%'}" class="warning-icon" >
        {@html result.overlapping.icon}
    </span>    
    {/if}
</div>


